import { Link } from 'react-router-dom'

import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type {
  CalendarEmployeeData,
  CalendarEmployeeLookup,
} from 'modules/calendar/lib/calendarEmployeeData'
import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

import styles from './index.module.css'

interface Props {
  event: CalendarEvent
  employeeId: string
  withDates: boolean
  employeeLookup: CalendarEmployeeLookup
}

const EmployeeEvent = ({ event, employeeId, withDates, employeeLookup }: Props) => {
  const { navigation } = useNavigation()

  const getName = (emp: CalendarEmployeeData): string => {
    const name = getFullDisplayName({
      firstName: emp.firstName,
      lastName: emp.lastName ?? '',
      canSharePreferredName: emp._policies?.sharePreferredName.can ?? false,
      preferredName: emp.preferredName ?? undefined,
    })
    if (withDates) {
      const day = moment(event.attributes.date).format('dddd')
      return i18n.t('calendar.event_date_with_name', {
        name,
        day,
      })
    } else {
      return name
    }
  }

  const emp = employeeLookup.get(employeeId)

  if (!emp) return null

  const canReadLeaves = emp._policies?.readLeaves.can ?? false

  if (!canReadLeaves) {
    return (
      <div className={styles.item}>
        <span>{getName(emp)}</span>
      </div>
    )
  }

  const to = navigation.employees.id.timeOff.fullPath({ id: emp.id })

  return (
    <Link to={to} className={styles.link}>
      <span>{getName(emp)}</span>
    </Link>
  )
}

export default EmployeeEvent
